import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Common from "../based/Common";
import CommonTable from "../based/CommonTable";
import { NOTIFY } from "../based/Constants";
import { ConfirmDialog } from "../based/Dialog";
import Loading from "../based/Loading";
import { Notify } from "../based/Notify";
import CheckBox from "../based/inputs/CheckBox";
import MarketingServices from "../based/services/MarketingServices";
import DragAndDropIndex from "../based/DragAndDropIndex";
import Request from "../based/Request";
import ModalConfigTime from "./modals/ModalConfigTimeReview";

const GIFT_TYPE_PARTNER = 1
const MarketingPartnerGift = ({campaignId, setBusy}) => {
    const [data , setData] = useState([])
    const tableRef = useRef(null);
    const [paging , setPaging] = useState({})
    const [giftItem , setGiftItem] = useState({})
    const [isShowModalConfig , setIsShowModalConfig] = useState(false);

    useEffect(() =>{
        getData()
    },[campaignId])

    const getData = async() => {
        setBusy(true);
        let [err, data] = await MarketingServices.GetGiftByCampaignId(campaignId,GIFT_TYPE_PARTNER);
        if (!err && data) {
            setData(data)
        } else {
            setData([]);
        }
        setBusy(false);
    }

    function _renderHeader() {
        return (
            <thead>
                <tr className="text-center">
                    <th>
                        STT
                    </th>
                    <th>Tên giải thưởng</th>
                    <th>Tổng phần quà</th>
                    <th>Số khung giờ đặc biệt</th>
                    <th>Action</th>
                </tr>
            </thead>
        );
    }


    function _renderBody() {
        return (
            <tbody>
                {" "}
                {data && data.length > 0 ? (
                    data.map((item, idx) => {
                        return (
                            <tr className={idx}>
                                <td style={{width: 100}}>{idx + 1}</td>
                                <td>
                                    {
                                        item.name
                                    }
                                </td>
                                <td style={{ width: 200 }}>{item.countTotalAllCampaign}</td>
                                <td style={{ width: 200 }}>{item.countSpecial}</td>
                                <td style={{ width: 200 }}>
                                    <button className={"btn btn-custom m-1"}
                                    onClick={()=>{
                                        setGiftItem(item)
                                        setIsShowModalConfig(true)
                                    }}
                                >Xem tỷ lệ</button>
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan={99}>Không có dữ liệu</td>
                    </tr>
                )}

            </tbody>
        );
    }

    function _renderAction() {
       return <div className="title-product">
            Quà tặng của partner
       </div>
    }


    return <div>
            {isShowModalConfig && <ModalConfigTime isShowModal={isShowModalConfig} onClose={()=>{
                setIsShowModalConfig(false)
                setGiftItem({})
            }} gift={giftItem} 
            campaignId={campaignId}
            />}
            <CommonTable data={data} paging={paging} hideSearchBasicButton 
                renderAction={_renderAction} 
                renderHeader={_renderHeader} 
                renderBody={_renderBody} 
                ref={tableRef} 
             />
    </div>
}

export default MarketingPartnerGift